import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// 🔄 Auto-reload quando o app antigo tenta carregar um chunk que sumiu após deploy.
// Evita o "Failed to fetch dynamically imported module" pra quem deixa a aba aberta.
const RELOAD_FLAG = 'escalone:chunk-reload';
const isChunkLoadError = (msg: string) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk \d+ failed/i.test(msg);
const tentarReload = () => {
  try {
    const ja = sessionStorage.getItem(RELOAD_FLAG);
    const agora = Date.now();
    // Evita loop: só recarrega se não tentou nos últimos 10s
    if (ja && agora - Number(ja) < 10_000) return;
    sessionStorage.setItem(RELOAD_FLAG, String(agora));
    window.location.reload();
  } catch {
    window.location.reload();
  }
};
window.addEventListener('error', (event) => {
  const msg = event?.message || (event?.error && event.error.message) || '';
  if (isChunkLoadError(msg)) tentarReload();
});
window.addEventListener('unhandledrejection', (event) => {
  const reason: any = event?.reason;
  const msg = typeof reason === 'string' ? reason : reason?.message || '';
  if (isChunkLoadError(msg)) tentarReload();
});

// Cache-bust: v2025-08-22-final
ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);